import BaseService from './baseService';
import { ScenarioFilter } from 'store/psoLogs/types';

export default class PSOLogsService extends BaseService {
    constructor() {
        super('psoLogs');
    }

    /**
     * Gets Scenarios
     * @param {Object} filter 
     * @param {number} filter.pageNumber
     * @param {number} filter.pageSize
     * @param {string} filter.searchString
     * @param {number} filter.taskId
     * @returns List of Scenarios
     */
    getScenarios = (filter: ScenarioFilter) => this.httpPostRequest('scenarios', filter);

    /**
     * Loads Scenarios
     * @param {Array<number>} scenarioIds 
     * @returns void
     */
    loadScenarios = (scenarioIds: number[]) => this.httpPostRequest('loadScenarios', { scenarioIds });

    /**
     * Gets dashboard
     * @param {Object} params
     * @param {Array<string>} params.tables - tables type: getWarningsTypes, compareWarningsTypes
     * @param {Object} params.filters
     * @param {number} params.filters.scenarioId
     * @param {number} params.filters.targetId - optional scenarioId for comparing
     * @returns Dashboard in json string format
     */
    getDashboard = ({ tables, filters }: {
        tables: string[],
        filters: {
            scenarioId: number;
            targetId?: number;
        }
    }) => this.httpPostRequest('getDashboard', { tables, filters });

    /**
     * Generates logs for download
     * @param filter 
     * @returns url
     */
    dumpScenarioLogs = (filter: {
        logLevels: string[];
        compareRules: string[];
        scenarioIds: number[];
    }) => this.httpPostRequest('dumpScenarioLogs', filter);
}
